'use client'

import { Button } from '@/components/ui/button'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Autoplay from 'embla-carousel-autoplay'
import { ArrowRight } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'

const lifestyleImages = [
  { image: '/image/2026/10/05/smm_lifestyle_1.jpg', labelKey: 'item1' },
  { image: '/image/2026/10/05/smm_lifestyle_2.jpg', labelKey: 'item2' },
  { image: '/image/2026/10/05/smm_lifestyle_3.jpg', labelKey: 'item3' },
] as const

const MOBILE_AUTOPLAY = {
  delay: 3000,
  stopOnInteraction: false,
  breakpoints: { '(min-width: 1024px)': { active: false } },
}

export const SeamlessMotionLifestyle = () => {
  const t = useTranslations('seamless_motion_hardcode.lifestyle')

  return (
    <section className='grid gap-6 bg-neutral-50 px-5 py-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,57.4%)] lg:items-center lg:gap-10 lg:py-0 lg:pl-15 lg:pr-0'>
      <div className='grid gap-4 lg:gap-6'>
        <div className='grid gap-1'>
          <p className='font-criteria text-xs uppercase tracking-[0.02em] text-black lg:text-lg'>
            {t('eyebrow')}
          </p>
          <h2 className='bg-gradient-to-r from-[#2E433C] to-[#74A997] bg-clip-text font-criteria text-[32px] font-semibold uppercase leading-[41px] tracking-[-0.02em] text-transparent lg:text-5xl lg:font-bold lg:leading-[1.1] lg:tracking-[-0.03em] 2xl:text-[55px] 2xl:leading-[76px] 2xl:tracking-[-0.02em]'>
            {t('title_line1')}
            <br />
            {t('title_line2')}
          </h2>
        </div>
        <p className='text-base text-[#242424] lg:text-[22px] lg:leading-[30px]'>
          {t('description')}
        </p>
        <div className='grid justify-items-start gap-2 lg:auto-cols-max lg:grid-flow-col lg:gap-6'>
          <Button
            size='large'
            variant='black'
            className='px-10'
            onClick={() => {
              document.getElementById('collection-listing')?.scrollIntoView({
                behavior: 'smooth',
              })
            }}
          >
            {t('buy_now')}
            <ArrowRight className='!size-5' />
          </Button>
          <Button
            asChild
            size='large'
            variant='outline-neutral'
            className='px-10'
          >
            <Link href='/highlight-collections'>
              {t('explore_more')}
              <ArrowRight className='!size-5' />
            </Link>
          </Button>
        </div>
      </div>

      {/* Mobile: slide ngang tự chạy, desktop: tắt slide, 3 ảnh ghép liền nhau */}
      <Carousel
        opts={{
          align: 'start',
          loop: true,
          breakpoints: { '(min-width: 1024px)': { active: false } },
        }}
        plugins={[Autoplay(MOBILE_AUTOPLAY)]}
        className='w-full'
      >
        <CarouselContent className='ml-0'>
          {lifestyleImages.map((item) => (
            <CarouselItem
              key={item.labelKey}
              className='basis-[73%] pl-0 lg:basis-1/3'
            >
              <div className='relative aspect-[245/400] lg:aspect-[367/600]'>
                <Image
                  src={ImageHelper.getImageUrlCdn(item.image)}
                  alt={t(`images.${item.labelKey}`)}
                  fill
                  sizes='(min-width: 1024px) 20vw, 73vw'
                  className='object-cover'
                />
                <p className='absolute bottom-5 left-3 font-criteria text-lg uppercase tracking-[-0.02em] text-white [text-shadow:0_2px_4px_rgba(0,0,0,0.25)] lg:left-5'>
                  {t(`images.${item.labelKey}`)}
                </p>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </section>
  )
}
